<template>
    <VAppLayout>
        <section class="home">
            <div>
                <transition name="slide-up">
                    <div v-if="activeItemId" class="test-modal" id="modal1" title="BootstrapVue">
                        <ItemDetails @myEvent="closeActiveItem()" :id="activeItemId" :image="activeItemImage"
                                     :name="activeItemName"></ItemDetails>
                    </div>
                </transition>

                <!-- Page Content -->
                <transition name="fade">

                    <div class="page-content content-area pt-40 bottom-sp60">

                        <div class="container">

                            <div class="notification-bar">
                                <div class="info">
                                    <span class="text">{{ $t('Welcome to') }}</span>
                                    <h2 class="title">{{ this.$store.state.companyData.locale.name }}</h2>
                                </div>
                                <div class="media">
                                    <img @click="langChangeButton()" src="img/lang.jpg" alt="" id="lang-img">
                                    <i class="fa fa-circle color-theme-orange active"></i>
                                </div>
                            </div>

                            <!-- Promotion Swiper -->
                            <div
                                v-if="this.$store.state.companyData.promotions && this.$store.state.companyData.promotions.length > 0">
                                <div class="title-bar">
                                    <h5 class="dz-title">{{ $t("Promotion") }}</h5>
                                </div>
                                <div data-space-between="15" data-slides-per-view="auto" data-centered-slides="false"
                                     class="swiper-container swiper-init pro-swiper swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events">
                                    <div class="swiper-wrapper" id="swiper-wrapper-36d2d9924ad101465" aria-live="polite"
                                         style="transform: translate3d(0px, 0px, 0px);">

                                        <div v-for="(promotionItem, i) in this.$store.state.companyData.promotions"
                                             :key="i"
                                             class="swiper-slide swiper-slide-active" role="group" aria-label="1 / 3"
                                             style="margin-right: 15px;">
                                            <router-link :to="{
                                name: 'promotion',
                                params: {
                                  id: promotionItem.id,
                                  name: promotionItem.name,
                                  image_url: promotionItem.image_url,
                                  color: promotionItem.color
                              }}"
                                                         class="card-overlay"
                                                         v-bind:style="{ 'background-color': promotionItem.color }"
                                                         style="background-image: url(img/background/card-bg.png); ">
                                                <div class="dz-info">
                                                    <div class="dz-head">
                                                        <h5 class="item-title title">
                                                            <a href="/item-details/">
                                                                {{ promotionItem.name }}
                                                            </a>
                                                        </h5>
                                                    </div>
                                                    <div class="dz-meta">
                                                        <!--                        <ul>-->
                                                        <!--                          <li class="price">$5.8 <del>$9.9</del></li>-->
                                                        <!--                        </ul>-->
                                                    </div>
                                                </div>
                                                <div class="dz-media">
                                                    <img v-if="promotionItem.image_url"
                                                         v-bind:src="promotionItem.image_url"
                                                         alt="">
                                                </div>
                                            </router-link>
                                        </div>
                                    </div>
                                    <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                                </div>
                            </div>


                            <!-- Categories -->
                            <div class="title-bar">
                                <h5 class="dz-title">{{ $t("Categories") }}</h5>
                                <router-link :to="{ name: 'full-menu'}" class="button text-capitalize">
                                    {{ $t('Full menu') }}
                                </router-link>
                            </div>


                            <div data-space-between="20" data-slides-per-view="auto" data-centered-slides="false"
                                 class="swiper-container swiper-init mb-40 categories-swiper swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events">
                                <div class="swiper-wrapper" id="swiper-wrapper" aria-live="polite">

                                    <div v-for="(category, i) in this.$store.state.companyData.menu" :key="i"
                                         class="swiper-slide swiper-slide-active" role="group" aria-label="1 / 6"
                                         style="margin-right: 20px;">
                                        <div class="categories-bx"
                                             :style="{'background-color': $store.state.companyData.colors.main}">
                                            <!--                  <div class="icon-bx">-->
                                            <!--                    <router-link :to="{ name: 'full-menu', params: { id: category.id }}">-->
                                            <!--                      <svg enable-background="new 0 0 48 48" height="38" viewBox="0 0 48 48" width="38" xmlns="http://www.w3.org/2000/svg">-->
                                            <!--                        <g><g><g><path d="m30.1 47.5h-21.8c-.9 0-1.7-.7-1.9-1.6l-5.9-30.5c-.1-.6 0-1.2.4-1.6.4-.5.9-.7 1.5-.7h33.5c.6 0 1.1.3 1.5.7s.5 1 .4 1.6l-5.8 30.5c-.2.9-1 1.6-1.9 1.6zm-20.2-3.9h18.6l5.1-26.6h-28.8z" fill="#fff"></path></g>-->
                                            <!--                          <g><path d="m31.3 42.3c-.5 0-1.1-.2-1.5-.7-.7-.8-.6-2.1.2-2.8 3.9-3.4 6.1-5.5 9-8.2 1-.9 2-1.9 3.2-3 1.8-1.7 1.4-3.4.9-4.2-.9-1.7-3.3-3.1-6.5-2.4-1.1.2-2.1-.4-2.3-1.5s.4-2.1 1.5-2.3c4.5-1 8.9.9 10.8 4.5 1.6 3 .9 6.4-1.8 8.9-1.2 1.1-2.2 2.1-3.2 3-2.8 2.6-5.2 4.9-9.1 8.3-.3.2-.7.4-1.2.4z" fill="#fff"></path></g></g>-->
                                            <!--                          <g><path d="m9.3 10.1c-1.1 0-2-.9-2-2v-5.6c0-1.1.9-2 2-2s2 .9 2 2v5.7c-.1 1-.9 1.9-2 1.9z" fill="#fff"></path></g>-->
                                            <!--                          <g><path d="m18.1 10.1c-1.1 0-2-.9-2-2v-5.6c0-1.1.9-2 2-2s2 .9 2 2v5.7c-.1 1-.9 1.9-2 1.9z" fill="#fff"></path></g>-->
                                            <!--                          <g><path d="m26.9 10.1c-1.1 0-2-.9-2-2v-5.6c0-1.1.9-2 2-2s2 .9 2 2v5.7c-.1 1-.9 1.9-2 1.9z" fill="#fff"></path></g></g>-->
                                            <!--                      </svg>-->
                                            <!--                    </router-link>-->
                                            <!--                  </div>-->
                                            <h6 class="title">
                                                <router-link :to="{ name: 'full-menu', params: { id: category.id }}">
                                                    {{ category.name }}
                                                </router-link>
                                            </h6>
                                            <span class="menus">{{ category.items }} Items</span>
                                            <svg class="bg-icon" enable-background="new 0 0 48 48" height="38"
                                                 viewBox="0 0 48 48" width="38" xmlns="http://www.w3.org/2000/svg">
                                                <g>
                                                    <g>
                                                        <g>
                                                            <path
                                                                d="m30.1 47.5h-21.8c-.9 0-1.7-.7-1.9-1.6l-5.9-30.5c-.1-.6 0-1.2.4-1.6.4-.5.9-.7 1.5-.7h33.5c.6 0 1.1.3 1.5.7s.5 1 .4 1.6l-5.8 30.5c-.2.9-1 1.6-1.9 1.6zm-20.2-3.9h18.6l5.1-26.6h-28.8z"
                                                                fill="#fff"></path>
                                                        </g>
                                                        <g>
                                                            <path
                                                                d="m31.3 42.3c-.5 0-1.1-.2-1.5-.7-.7-.8-.6-2.1.2-2.8 3.9-3.4 6.1-5.5 9-8.2 1-.9 2-1.9 3.2-3 1.8-1.7 1.4-3.4.9-4.2-.9-1.7-3.3-3.1-6.5-2.4-1.1.2-2.1-.4-2.3-1.5s.4-2.1 1.5-2.3c4.5-1 8.9.9 10.8 4.5 1.6 3 .9 6.4-1.8 8.9-1.2 1.1-2.2 2.1-3.2 3-2.8 2.6-5.2 4.9-9.1 8.3-.3.2-.7.4-1.2.4z"
                                                                fill="#fff"></path>
                                                        </g>
                                                    </g>
                                                    <g>
                                                        <path
                                                            d="m9.3 10.1c-1.1 0-2-.9-2-2v-5.6c0-1.1.9-2 2-2s2 .9 2 2v5.7c-.1 1-.9 1.9-2 1.9z"
                                                            fill="#fff"></path>
                                                    </g>
                                                    <g>
                                                        <path
                                                            d="m18.1 10.1c-1.1 0-2-.9-2-2v-5.6c0-1.1.9-2 2-2s2 .9 2 2v5.7c-.1 1-.9 1.9-2 1.9z"
                                                            fill="#fff"></path>
                                                    </g>
                                                    <g>
                                                        <path
                                                            d="m26.9 10.1c-1.1 0-2-.9-2-2v-5.6c0-1.1.9-2 2-2s2 .9 2 2v5.7c-.1 1-.9 1.9-2 1.9z"
                                                            fill="#fff"></path>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                            </div>

                            <!-- Featured Beverages -->
                            <div
                                v-if="this.$store.state.companyData.featuredItems && this.$store.state.companyData.featuredItems.length > 0">
                                <div class="title-bar">
                                    <h5 class="dz-title">
                                        {{ $t("Featured Beverages") }}
                                    </h5>
                                    <!--          <a href="/products/" class="button text-capitalize">More</a>-->
                                </div>
                                <div data-space-between="20" data-slides-per-view="auto" data-centered-slides="false"
                                     class="swiper-container swiper-init item-swiper swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events">
                                    <div class="swiper-wrapper" aria-live="polite"
                                         style="transform: translate3d(0px, 0px, 0px);">
                                        <div v-for="(featuredItem, i) in this.$store.state.companyData.featuredItems"
                                             :key="i" class="swiper-slide swiper-slide-active" role="group"
                                             aria-label="1 / 4" style="margin-right: 20px;">
                                            <div class="item-bx item-grid">
                                                <div class="dz-media">
                            <span @click="setActiveItem(featuredItem)">
                              <div v-if="featuredItem.image" class="dish-image"
                                   v-bind:style="{ backgroundImage: 'url(' + featuredItem.image + ')' }"></div>
                              <div v-if="!featuredItem.image" class="dish-image placeholder"
                                   v-bind:style="{ backgroundImage: 'url(' + require('@/assets/img/menus/pic1.jpg') + ')' }"></div>
                                <!--                      <img v-if="!featuredItem.image" src="@/assets/img/menus/pic1.jpg" alt="">-->
                            </span>
<!--                                                    <span @click="setActiveItem(featuredItem)" class="cart-btn">-->
<!--                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"-->
<!--                                   xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path-->
<!--                                    d="M21.733 21.68C21.8274 21.5791 21.8999 21.4598 21.9458 21.3295C21.9918 21.1992 22.0102 21.0608 22 20.923L21 7.923C20.9806 7.67135 20.8667 7.43636 20.6813 7.26517C20.4958 7.09397 20.2524 6.99925 20 7H17C17 5.67392 16.4733 4.40215 15.5356 3.46447C14.5979 2.52678 13.3261 2 12 2C10.674 2 9.40219 2.52678 8.46451 3.46447C7.52682 4.40215 7.00004 5.67392 7.00004 7H4.00004C3.74764 6.99925 3.50429 7.09397 3.31882 7.26517C3.13335 7.43636 3.01947 7.67135 3.00004 7.923L2.00004 20.923C1.98941 21.0607 2.0074 21.199 2.05287 21.3294C2.09834 21.4597 2.17031 21.5793 2.26425 21.6804C2.35819 21.7816 2.47206 21.8622 2.5987 21.9172C2.72533 21.9722 2.86198 22.0004 3.00004 22H21C21.1377 22 21.2738 21.9715 21.3999 21.9165C21.5261 21.8614 21.6395 21.7809 21.733 21.68ZM12 4C12.7957 4 13.5588 4.31607 14.1214 4.87868C14.684 5.44129 15 6.20435 15 7H9.00004C9.00004 6.20435 9.31611 5.44129 9.87872 4.87868C10.4413 4.31607 11.2044 4 12 4ZM4.08004 20L4.92604 9H7.00004V11C7.00004 11.2652 7.1054 11.5196 7.29293 11.7071C7.48047 11.8946 7.73482 12 8.00004 12C8.26526 12 8.51961 11.8946 8.70715 11.7071C8.89468 11.5196 9.00004 11.2652 9.00004 11V9H15V11C15 11.2652 15.1054 11.5196 15.2929 11.7071C15.4805 11.8946 15.7348 12 16 12C16.2653 12 16.5196 11.8946 16.7071 11.7071C16.8947 11.5196 17 11.2652 17 11V9H19.074L19.92 20H4.08004Z"-->
<!--                                    fill="#4A3749"></path>-->
<!--                              </svg>-->
<!--                            </span>-->
                                                </div>
                                                <div class="dz-info">
                                                    <!--                  <ul class="tag-list">-->
                                                    <!--                    <li><a href="/item-details/">Tea</a></li>-->
                                                    <!--                  </ul>-->
                                                    <div class="dz-head">
                                                        <h6 class="item-title"><span
                                                            @click="setActiveItem(featuredItem)">{{
                                                                featuredItem.name
                                                            }} </span>
                                                        </h6>
                                                    </div>

                                                    <div class="dz-meta">
                                                        <ul>
                                                            <li class="price"> {{ featuredItem.price }} zł</li>

                                                            <i v-if="featuredItem.is_vegetarian"
                                                               class="iconmoon-vegeterian"
                                                               @click="showIconDetails('vegeterian')"></i>
                                                            <i v-if="featuredItem.is_gluten_free"
                                                               class="iconmoon-gluten-free"
                                                               @click="showIconDetails('gluten-free')"></i>
                                                            <i v-if="featuredItem.is_spicy"
                                                               class="iconmoon-chili-pepper"
                                                               @click="showIconDetails('chili-pepper')"></i>
                                                            <i v-if="featuredItem.is_low_calorie"
                                                               class="iconmoon-low-calories"
                                                               @click="showIconDetails('low-calories')"></i>


                                                            <!--                      <li class="rating">-->
                                                            <!--                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                                                            <!--                          <path d="M14.43 5.84598L10.552 5.27932L8.60004 1.36865C8.53844 1.26533 8.45107 1.17978 8.34648 1.12037C8.24189 1.06096 8.12366 1.02972 8.00338 1.02972C7.88309 1.02972 7.76486 1.06096 7.66027 1.12037C7.55568 1.17978 7.46831 1.26533 7.40671 1.36865L5.44804 5.27932L1.57004 5.84598C1.44247 5.86472 1.32308 5.92005 1.22631 6.00526C1.12955 6.09047 1.05957 6.20192 1.02486 6.32609C0.990146 6.45027 0.992187 6.58185 1.03073 6.70489C1.06928 6.82793 1.14268 6.93715 1.24204 7.01932L4.44538 9.66132L3.43538 14.188C3.40586 14.3199 3.41715 14.4577 3.46773 14.583C3.51832 14.7084 3.60582 14.8154 3.71863 14.8899C3.83144 14.9644 3.96422 15.0028 4.09937 15.0001C4.23452 14.9974 4.36566 14.9536 4.47537 14.8747L8.00004 12.3393L11.5247 14.8727C11.6344 14.9516 11.7656 14.9954 11.9007 14.9981C12.0359 15.0008 12.1686 14.9624 12.2815 14.8879C12.3943 14.8134 12.4818 14.7064 12.5324 14.581C12.5829 14.4557 12.5942 14.3179 12.5647 14.186L11.5547 9.65932L14.758 7.01732C14.8574 6.93515 14.9308 6.82593 14.9693 6.70289C15.0079 6.57985 15.0099 6.44827 14.9752 6.32409C14.9405 6.19992 14.8705 6.08847 14.7738 6.00326C14.677 5.91805 14.5576 5.86272 14.43 5.84398V5.84598ZM10.3907 8.89332C10.2959 8.97167 10.2246 9.07473 10.1847 9.1911C10.1448 9.30747 10.1379 9.4326 10.1647 9.55265L10.882 12.77L8.38938 10.9773C8.27596 10.8957 8.13976 10.8518 8.00004 10.8518C7.86032 10.8518 7.72413 10.8957 7.61071 10.9773L5.11804 12.77L5.83538 9.55265C5.8622 9.4326 5.85529 9.30747 5.8154 9.1911C5.77551 9.07473 5.70421 8.97167 5.60938 8.89332L3.25071 6.94798L5.98404 6.54798C6.09033 6.53249 6.1913 6.49154 6.27835 6.42863C6.36541 6.36572 6.43597 6.2827 6.48404 6.18665L8.00004 3.15665L9.51471 6.18665C9.56278 6.2827 9.63334 6.36572 9.7204 6.42863C9.80746 6.49154 9.90842 6.53249 10.0147 6.54798L12.748 6.94798L10.3907 8.89332Z" fill="#464646"></path>-->
                                                            <!--                        </svg>4.0-->
                                                            <!--                      </li>-->
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                                </div>
                            </div>
                            <div style="height:10px"></div>
                            <router-link :to="{ name: 'review', params: { tab: 'review' }}"
                                         class="button-large button button-fill">
                                    <span class="reviewBtn"
                                          v-if="this.$store.state.companyData.locale.smartmenu_action_btn_label">{{
                                            this.$store.state.companyData.locale.smartmenu_action_btn_label
                                        }}</span>
                                <span class="reviewBtn" v-else>{{ $t('SUBMIT REVIEW') }}</span>
                            </router-link>
                            <div style="height:20px"></div>
                            <hr>
                            <div id="powered-handler" class="text-center">
                                🌶️ Powered by <a
                                :href="'https://myrest.io?utm_source=smartmenu&utm_medium=' + this.$store.state.companyName"
                                target="_blank"><span style="font-size: 9px;">MY</span>REST</a>
                            </div>
                        </div>


                        <vue-bottom-sheet
                            ref="myBottomSheet"
                            @opened="notifyMainMenu(false)"
                            @closed="notifyMainMenu(true)"
                            max-height="90%"
                        >
                            <div class="padding-30">
                                <h1>{{ $t('Language') }}</h1>
                                <ul id="lang-list">
                                    <li @click="changeLanguage(language.code)"
                                        v-for="language in this.$store.state.companyData.languages"
                                        :key="language.code">
                                        <p>{{ getLangFlag(language.code) }} {{ language.name }}</p>
                                    </li>
                                </ul>
                                <div style="height:200px"></div>
                            </div>
                        </vue-bottom-sheet>

                        <vue-bottom-sheet
                            ref="iconDetails"
                            @opened="notifyMainMenu(false)"
                            @closed="notifyMainMenu(true)"
                            max-height="90%"
                        >
                            <div class="padding-30">
                                <div v-if="activeIcon">
                                    <div class="text-align-center">
                                        <i v-if="activeIcon.icon === 'iconmoon-vegeterian'"
                                           class="iconmoon-vegeterian font-40"></i>
                                        <i v-if="activeIcon.icon === 'iconmoon-gluten-free'"
                                           class="iconmoon-gluten-free font-40"></i>
                                        <i v-if="activeIcon.icon === 'iconmoon-chili-pepper'"
                                           class="iconmoon-chili-pepper font-40"></i>
                                        <i v-if="activeIcon.icon === 'iconmoon-low-calories'"
                                           class="iconmoon-low-calories font-40"></i>
                                        <h2>{{ $t(activeIcon.name) }}</h2>
                                        <p>{{ $t(activeIcon.description) }}</p>
                                    </div>

                                </div>
                                <div style="height:400px"></div>
                            </div>
                        </vue-bottom-sheet>

                    </div>
                </transition>
            </div>
        </section>
    </VAppLayout>


</template>

<script>

import i18n from "../../i18n";
import {BASE_API_URL} from "@/appConstants";
import axios from "axios";
import router from "../../router/router";
import ItemDetails from "../ItemDetails";
import VAppLayout from "@/layouts/VAppLayout.vue";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";


export default {
    name: "HomeIndex",
    components: {
        VueBottomSheet,
        VAppLayout,
        ItemDetails
    },
    data() {
        return {
            activeItemId: null,
            activeItemImage: null,
            activeItemName: null,
            activeIcon: null,
            iconsOptions: {
                "vegeterian": {
                    "name": "vegeterian",
                    "description": "vegeterian-description",
                    "icon": "iconmoon-vegeterian"
                },
                "gluten-free": {
                    "name": "gluten-free",
                    "description": "gluten-free-description",
                    "icon": "iconmoon-gluten-free"
                },
                "chili-pepper": {
                    "name": "chili-pepper",
                    "description": "chili-pepper-description",
                    "icon": "iconmoon-chili-pepper"
                },
                "low-calories": {
                    "name": "low-calories",
                    "description": "low-calories-description",
                    "icon": "iconmoon-low-calories"
                },
            }
        }
    },
    created() {

    },
    methods: {
        setActiveItem(item) {
            this.activeItemImage = item.image;
            this.activeItemName = item.name;
            this.activeItemId = item.id;
        },
        closeActiveItem() {
            this.activeItemImage = null;
            this.activeItemName = null;
            this.activeItemId = null;
        },
        langChangeButton() {
            this.$refs.myBottomSheet.open();
        },
        close() {
            this.$refs.myBottomSheet.close();
        },
        notifyMainMenu(state) {
            this.$store.commit('showBottomMenu', state);
        },
        changeLanguage(code) {
            i18n.locale = code;
            this.$refs.myBottomSheet.close();
            this.$store.commit('setPrefLangCode', code);
            this.notifyMainMenu(true);
            this.updateServerTokenLanguage();
            this.reloadCompanyData();
        },
        getLangFlag(code) {
            let langFlag = '🇬🇧';
            switch (code) {
                case 'en':
                    return langFlag;
                case 'pl':
                    return '🇵🇱';
                case 'de':
                    return '🇩🇪';
                case 'ru':
                    return '🇷🇺';
                case 'ua':
                    return '🇺🇦';
                case 'ko':
                    return '🇰🇷';
                case 'es':
                    return '🇪🇸';
                case 'it':
                    return '🇮🇹';
                case 'fr':
                    return '🇫🇷';
                case 'tr':
                    return '🇹🇷';
                case 'he':
                    return '🇮🇱';
                default:
                    return langFlag
            }
        },
        reloadCompanyData() {
            const endpoint = BASE_API_URL +
                'locale?code=' + this.$store.state.companyName +
                '&identifier=' + this.$store.getters.getFingerprint +
                '&pref_lang_code=' + this.$store.state.prefLangCode;
            axios.get(endpoint).then(
                response => {
                    this.companyData = response.data;
                    this.$store.commit('saveCompanyData', this.companyData);
                    console.log('loaded');
                }
            ).catch(error => {
                router.push('error');
                console.log(error);
            })
        },
        updateServerTokenLanguage() {
            const endpoint = BASE_API_URL +
                'changelanguage?token=' + this.$store.state.companyData.token +
                '&lang_code=' + this.$store.state.prefLangCode;
            axios.get(endpoint).then(
                response => {
                    console.log(response);
                }
            ).catch(error => {
                router.push('error');
                console.log(error);
            })
        },
        showIconDetails(icon) {
            this.activeIcon = this.iconsOptions[icon];
            this.$refs.iconDetails.open();
        }
    }

}
</script>

<style scoped>

>>> .app_layout-content{
    padding-left: 0;
    padding-right: 0;
}

.home {
    box-sizing: border-box;
}

#lang-img {
    border: 1px solid #fbf4fb;
    -webkit-box-shadow: 0px 0px 4px 1px rgba(66, 68, 90, 0.23);
    -moz-box-shadow: 0px 0px 4px 1px rgba(66, 68, 90, 0.23);
    box-shadow: 0px 0px 4px 1px rgba(66, 68, 90, 0.23);
    cursor: pointer;
}

#lang-list {
    list-style: none;
    padding: 0
}

.padding-30 {
    padding: 0 30px
}

#lang-list li {
    font-size: 30px;
    cursor: pointer;
    color: #1c1c1d;
    background-color: #f3f3f3;
    padding: 5px 10px;
    border-radius: 20px;
    margin: 0 0 9px 0;
}

#lang-list li p {
    padding: 0;
    line-height: 0;
}

#swiper-wrapper {
    overflow: scroll;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */
{
    opacity: 0
}

.dish-image {
    border-radius: 22px;
    min-height: 140px;
    display: flex;
    background-size: cover;
}

.swiper-wrapper {
    overflow: scroll;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */
{
    opacity: 0
}

.slide-up-enter-active {
    transition: all .4s ease;
}

.slide-up-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-up-enter, .slide-fade-leave-to {
    transform: translateY(100vh);
    opacity: 0;
}

.test-modal {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
    position: fixed;
    z-index: 100000;
    background-color: white;
}

.title a {
    height: 45px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
}

.reviewBtn {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    line-clamp: 1;
    -webkit-box-orient: vertical;
}

.dish-image.placeholder {
    background-position: center;
}

</style>
